import { useState } from "react";
import { faqList } from "@/mocks/nanaData";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100/70 px-4 py-14 md:px-6 md:py-16" aria-label="常见问题">
      <div className="mx-auto max-w-4xl">
        <div className="text-center">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-500">常见问题</span>
          <h2 className="mt-2 font-[ZCOOL_KuaiLe] text-3xl text-foreground-950">你想知道的都在这里</h2>
          <p className="mt-2 text-sm text-foreground-500">关于娜娜51热评圈，你可能关心的问题。</p>
        </div>

        <div className="mt-8 space-y-3">
          {faqList.map((item, idx) => {
            const isOpen = openIdx === idx;
            return (
              <div key={item.q} className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
                <button
                  onClick={() => setOpenIdx(isOpen ? null : idx)}
                  className="flex w-full cursor-pointer items-center justify-between gap-3 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <h3 className="text-sm font-semibold text-foreground-900 md:text-base">{item.q}</h3>
                  <i
                    className={`ri-add-line shrink-0 text-xl text-primary-500 transition-transform duration-200 ${isOpen ? "rotate-45" : ""}`}
                  ></i>
                </button>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: faqList.map((f) => ({
                "@type": "Question",
                name: f.q,
                acceptedAnswer: { "@type": "Answer", text: f.a },
              })),
            }),
          }}
        />
      </div>
    </section>
  );
}